import { render, staticRenderFns } from "./NumberInputField.vue?vue&type=template&id=585e6010&scoped=true"
import script from "./NumberInputField.vue?vue&type=script&lang=js"
export * from "./NumberInputField.vue?vue&type=script&lang=js"
import style0 from "./NumberInputField.vue?vue&type=style&index=0&id=585e6010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e6010",
  null
  
)

export default component.exports